import throttle from 'lodash.throttle';
import {
    completeSentimentPoll,
    reanswerSentimentPoll
} from '../../utils/sentimentPoll/sentimentPollApi';
import { trackContent } from '../../utils/facebookPixel';
import { ACTION_COMPLETED_LOCAL_REP, onFinishMultiAction } from '../Widget/actions';

const submitAnswer = (
    apiRequestData,
    actionCompletedTime,
    sentimentValue,
    answerId = null
) => {
    if (answerId) {
        return reanswerSentimentPoll(
            apiRequestData,
            actionCompletedTime,
            sentimentValue,
            answerId
        );
    } else {
        return completeSentimentPoll(apiRequestData, actionCompletedTime, sentimentValue);
    }
};

const throttledSubmitAnswer = throttle(submitAnswer, 500, {
    leading: true,
    trailing: false
});

const updateDistribution = (oldDistribution, userAnswer) => {
    let res = JSON.parse(JSON.stringify(oldDistribution));
    if (userAnswer === 1) {
        res[oldDistribution.length - 1] += 1;
    } else {
        res[Math.floor(oldDistribution.length * userAnswer)] += 1;
    }
    return res;
};

export const PRESET_DISTRIBUTION_DATA = 'PRESET_DISTRIBUTION_DATA';
export const SENTIMENT_POLL_ANSWER_SUBMITTING = 'SENTIMENT_POLL_ANSWER_SUBMITTING';
export const SENTIMENT_POLL_INITIATED = 'SENTIMENT_POLL_INITIATED';
export const SENTIMENT_POLL_SUCCESS = 'SENTIMENT_POLL_SUCCESS';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';
export const SENTIMENT_POLL_ANSWERED = 'SENTIMENT_POLL_ANSWERED';

let redirected = false;

export const sentimentPollAnswered = () => dispatch => {
    dispatch({ type: SENTIMENT_POLL_ANSWERED });
};

export const setPresetDistributionData = (
    distributionData,
    sentimentValue
) => dispatch => {
    dispatch({
        type: PRESET_DISTRIBUTION_DATA,
        payload: updateDistribution(distributionData, sentimentValue)
    });
};

export const onInteractWithSlider = (actionInitated, actionIdentifier) => dispatch => {
    if (!actionInitated) {
        dispatch({ type: SENTIMENT_POLL_INITIATED, payload: actionIdentifier });
    }
    dispatch({
        type: SENTIMENT_POLL_ANSWER_SUBMITTING,
        payload: true
    });
};

export const onPollAnswered = (
    apiRequestData,
    actionIdentifier,
    actionCompletedTime,
    questionText,
    sentimentValue,
    isMultiActionCard,
    answerId,
    isPollAnswered,
    feedbackText,
    noOfAnswers
) => dispatch => {
    trackContent(
        'sentimentPoll',
        apiRequestData.widgetId,
        actionIdentifier,
        questionText,
        sentimentValue,
        sentimentValue
    );

    const request = isPollAnswered
        ? throttledSubmitAnswer(
              apiRequestData,
              actionCompletedTime,
              sentimentValue,
              answerId
          )
        : throttledSubmitAnswer(apiRequestData, actionCompletedTime, sentimentValue);

    request
        .then(data => {
            dispatch({
                type: SENTIMENT_POLL_ANSWER_SUBMITTING,
                payload: false
            });

            dispatch({
                type: SENTIMENT_POLL_SUCCESS,
                payload: {
                    answerId: data.id,
                    resultDistribution: data.resultDistribution,
                    feedbackText,
                    questionText,
                    sentimentValue,
                    noOfAnswers,
                    actionIdentifier
                }
            });
            dispatch({
                type: ACTION_COMPLETED_LOCAL_REP,
                payload: actionIdentifier
            });

            if (isMultiActionCard && !redirected) {
                redirected = true;
                setTimeout(() => {
                    onFinishMultiAction(actionIdentifier)(dispatch);
                }, 5000);
            }
        })
        .catch(err => console.error(err));
};
